import api from 'configs/api'
import React from 'react'
import { IDashMetrics } from './Interfaces'

export const findDashMetrics = async (
  setMetrics: React.Dispatch<React.SetStateAction<IDashMetrics>>,
  month: string,
  setLoading?: React.Dispatch<React.SetStateAction<boolean>>
): Promise<void> => {
  try {
    setLoading?.(true)
    const dataInStorage: any = window.localStorage.getItem('@StarBem:user')
    const dataParse = JSON.parse(dataInStorage)

    const find = await api.get(
      `/schedulings/ms/v1/reports/appointments/doctor/month?doctor_id=${dataParse.id}&month=${month}`
    )

    const metrics = find.data
    setMetrics({
      ...metrics,
      started: metrics.started ?? '0',
      slots_occupied: metrics.slots_occupied ?? 0,
      slots_total: metrics.slots_total ?? 0,
    })
  } catch (err) {
    console.error(err)
  } finally {
    setLoading?.(false)
  }
}
